// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);

        // Remove focus from any lingering menu item or button
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
